import {createModel} from '@@/package/utils/ModelUtil';

export class MultipleChoiceResultModel {
  constructor(
    public id: number = 0,
    public testQuestionId: number = 0,
    public userId: number = 0,
    public answerList: Array<number> = []
  ) {}

  public static create(model: Partial<MultipleChoiceResultModel>): MultipleChoiceResultModel {
    return createModel<MultipleChoiceResultModel>(MultipleChoiceResultModel, {
      ...model
    });
  }
}
